export default "__VITE_ASSET__CwZcnu2M__"